<template>
  <v-row justify="center" class="menu-loader">
    <v-col cols="12" align-self="center">
      <div class="menu-loader__title">
        {{ $t('messages.loading-in-progress') }}
      </div>
      <v-progress-circular
        indeterminate
        color="primary"
        size="150"
        width="15"
      />
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: 'TheMenuLoader',
  }
</script>

<style lang="sass" scoped>
  @import "@/assets/styles/_config.sass"

  .menu-loader
    height: 100vh

  .v-application .v-progress-circular
    margin: auto
    display: block
    color: $primary-color !important

  .menu-loader__title
    text-align: center
    font-size: 50px
    color: red
    margin-bottom: 150px
</style>
